"use client";

import styles from "@/styles/newsletters/unsubscribe.module.scss";
import { useState } from "react";
import myAccountApi from "@/service/modules/myAccountApi";
import { Button, Input, Form } from "react-vant";

interface FormProps {
  onSuccess: (email: string) => void;
}

export default function NewslettersUnSubscribe({ onSuccess }: FormProps) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onFinish = async (values: { email: string }) => {
    try {
      setLoading(true);

      const dataObj = {
        email: values.email,
      };

      const finnalParams = Object.fromEntries(
        Object.entries(dataObj).filter(
          ([, value]) => value !== null && value !== ""
        )
      );

      const res = await myAccountApi.checkSubscribe(finnalParams);
      setLoading(false);

      // @ts-expect-error API response type mismatch - res.code property not defined in type
      if (res.code === 100000) {
        // 下一步
        if (onSuccess) onSuccess(values.email);
      } else {
        setErrorMessage(res.data.message);
      }
    } catch (error: any) {
      setLoading(false);
      setErrorMessage(error.message);
    }
  };

  return (
    <div className={styles["unsubscribe-form"]}>
      <Form
        form={form}
        onFinish={onFinish}
        layout={"vertical"}
        footer={
          <div>
            <Button
              round
              nativeType="submit"
              type="primary"
              style={{ fontWeight: "700", marginTop: "32px" }}
              loading={loading}
              loadingText="Submit"
              block
            >
              Unsubscribe
            </Button>
          </div>
        }
      >
        <Form.Item
          rules={[
            { required: true, message: `Please input email !` },
            { type: "email", message: `Error email !` },
          ]}
          name="email"
          label="Please enter your email address:"
        >
          <Input placeholder="Email address" maxLength={225} />
        </Form.Item>

        {errorMessage ? (
          <div
            className={styles["error-message"]}
            dangerouslySetInnerHTML={{ __html: errorMessage }}
          ></div>
        ) : null}
      </Form>
    </div>
  );
}
